var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeBottomGift(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 364,
    height: 122,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m52.8 20.862 13.335 5.96-17.167 38.404-13.333-5.96L52.8 20.861z",
    fill: "#ED7D2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.134 26.819 35.225 15.745-17.167 38.404-35.224-15.745 17.166-38.404z",
    fill: "#F99746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.284 48.754 1.208-2.692L92.78 61.898l-1.208 2.692-35.288-15.837z",
    fill: "#FFB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.896 42.847 1.208-2.692L57.46 46.15l-1.208 2.692-13.357-5.995z",
    fill: "#F69B34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.205 30.34s-9.09-10.038-17.903-11.605l1.114 1.73-1.63 1.477s9.854 1.625 18.512 8.797l-.093-.398zM77.404 31.072s1.526.46 3.82 1.115c6.083 1.737 17.546 4.823 20.161 4.186 4.101-.998 1.434-13.989-1.044-16.708-2.478-2.719-22.937 11.407-22.937 11.407z",
    fill: "#FFB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.346 9.427c-1.558 2.182 15.97 22.55 15.97 22.55s.084-1.28.194-3.297c.397-7.366 1.106-24.558-.878-25.209a2.489 2.489 0 0 0-.751-.098c-3.483-.029-13.104 4.04-14.535 6.054z",
    fill: "#FFB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.43 5.641c.278 2.962 2.194 22.645 2.215 22.95.405-7.326 1.142-24.428-.764-25.069a1.214 1.214 0 0 0-.722-.096c-.43.1-.883.58-.729 2.215zM81.866 32.068c5.871 1.8 16.937 4.992 19.476 4.283 1.915-2.156-.173-3.399-1.68-4.33-1.508-.932-17.796.047-17.796.047z",
    fill: "#F69B34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.722 33.545s.018-3.319-2.344-4.547c-2.468-1.283-5.302 1.164-5.302 1.164l7.647 3.383z",
    fill: "#F69B34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.57 26.57 36.857 16.474-2.361 5.283-36.858-16.475 2.361-5.282z",
    fill: "#FFA15A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.676 20.358 13.893 6.21-2.361 5.282-13.893-6.21 2.361-5.282z",
    fill: "#F78639"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.703 32.307s8.166.937 12.31 4.736c4.775 4.377 1.347 11.403 1.347 11.403l-1.064-1.168-2.142.049s2.985-7.744-1.078-10.897c-3.523-2.735-9.373-4.123-9.373-4.123z",
    fill: "#FFBE55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.171 34.884 2.687 1.201L69.544 74.82l-2.687-1.2 17.314-38.736z",
    fill: "#FFB93E"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164.811 45.04c-3.053-3.137-8.636-1.891-11.073 1.986-1.066 1.695 1.583 2.864 2.645 1.175 1.439-2.297 4.761-2.46 6.389-.788 1.292 1.327 3.324-1.052 2.039-2.372z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M166.777 10.109c-1.614.221-1.19 3.543.416 3.324 3.137-.429 6.122.918 8.475 3.547 1.224 1.368 2.703-1.465 1.487-2.822-2.883-3.23-6.578-4.568-10.378-4.05z",
    fill: "#3F964F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M146.353 14.037a3.418 3.418 0 0 0-4.67 1.656 3.717 3.717 0 0 0 1.719 4.832 3.422 3.422 0 0 0 4.67-1.656 3.717 3.717 0 0 0-1.719-4.832zM136.056 40.768c-1.143-1.159-3.547 1.172-2.409 2.326 2.222 2.252 2.933 5.45 2.239 8.908-.362 1.8 2.791 1.284 3.149-.5.852-4.245-.285-8.003-2.979-10.734z",
    fill: "#E62552"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118.993 44.779a3.417 3.417 0 0 0-4.671 1.655 3.717 3.717 0 0 0 1.719 4.832 3.424 3.424 0 0 0 3.869-.537c.34-.315.613-.695.802-1.118a3.717 3.717 0 0 0-1.719-4.832z",
    fill: "#3F964F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.122 103.563c-3.872 3.135-10.014.977-12.246-3.732-.978-2.06 2.173-3.024 3.146-.973 1.318 2.79 5.05 3.421 7.114 1.749 1.639-1.326 3.616 1.637 1.986 2.956z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.341 99.36c-1.004-1.559 2.18-3.653 3.18-2.104 1.954 3.027 5.33 4.608 9.344 4.694 2.09.043.737 3.42-1.336 3.374-4.926-.097-8.82-2.297-11.188-5.965z",
    fill: "#3F964F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.602 78.806a3.895 3.895 0 0 1-2.03-5.263 4.23 4.23 0 0 1 5.449-2.095 3.893 3.893 0 0 1 2.03 5.263 4.23 4.23 0 0 1-5.449 2.095zM27.066 50.105c-1.848-.128-1.616-3.932.224-3.804 3.592.25 6.881-1.506 9.355-4.666 1.286-1.647 3.176 1.46 1.9 3.091-3.036 3.88-7.124 5.683-11.479 5.38z",
    fill: "#E62552"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.888 32.394a3.892 3.892 0 0 1-2.03-5.262 4.23 4.23 0 0 1 5.447-2.095 3.894 3.894 0 0 1 2.03 5.262 4.23 4.23 0 0 1-5.447 2.095z",
    fill: "#3F964F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M358.736 56.416c-.711 4.457-6.155 6.72-10.509 4.9-1.905-.797-.367-3.354 1.531-2.561 2.576 1.082 5.472-.752 5.851-3.128.301-1.885 3.426-1.086 3.127.79z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M331.412 75.848c-1.62-.442-.742-3.78.869-3.342 3.149.856 6.38-.122 9.136-2.494 1.434-1.235 2.567 1.858 1.143 3.082-3.378 2.916-7.333 3.791-11.148 2.754z",
    fill: "#3F964F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M311.062 69.106a3.523 3.523 0 0 1-4.552-2.317 3.828 3.828 0 0 1 2.402-4.709 3.528 3.528 0 0 1 4.553 2.317 3.832 3.832 0 0 1-2.403 4.709zM304.109 40.41c-1.324 1.033-3.47-1.67-2.153-2.698 2.572-2.006 3.725-5.18 3.478-8.806-.129-1.888 3.024-.94 3.152.933.303 4.451-1.36 8.14-4.477 10.571z",
    fill: "#E62552"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M287.205 34.033a3.53 3.53 0 0 1-3.883-1.065 3.529 3.529 0 0 1-.67-1.25 3.828 3.828 0 0 1 2.402-4.71 3.523 3.523 0 0 1 4.553 2.316 3.833 3.833 0 0 1-2.402 4.71z",
    fill: "#3F964F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 31.634,
    y: 3.372,
    width: 75.876,
    height: 85.596,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4714_20181"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4714_20181",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBottomGift);
export default __webpack_public_path__ + "static/media/home_bottom_gift.342a59ae4810ef90cf7700ac7ed23e46.svg";
export { ForwardRef as ReactComponent };